export const platformIos = () => {
  return navigator.userAgent.match(/iPhone|iPad|iPod/i);
};

export const platformAndroid = () => {
  return navigator.userAgent.match(/Android/i);
};

export const platformWeb = () => {
  return !platformIos() && !platformAndroid();
};
